import config from '../config/config.json';
import RestModel from './RestModel';
import translate from '../helpers/translateHelper';

const resourceName = 'role-screens';

export default {
    list: () => RestModel.list(`${resourceName}/${config.defaultLocale}`).then(l => l.map(i => translate(i, 'displayName')))
};
